import _ from 'lodash';
import 'createjs-soundjs';

export class cjsSound {
  _sound;

  construct() {
    this._sound = false;
  }

  init() {
    this._sound = createjs;
  }

  play(id) {
    if (!this.Sound.isReady() || !(id in this.Sound._idHash)) {
      return false;
    }

    let myInstance = createjs.Sound.play(id);
    myInstance.on('failed', function (e) {
      console.log('FAILED');
      console.log(e);
    });

    return true;
  }

  get Sound() {
    return this._sound.Sound;
  }

  set Sound(v) {
    this._sound.Sound = v;
  }
}
